<template>
    <div class="tabStyle">
        <img v-show="iconShow" @click="ToLeftFn" :src="require('../assets/img/ToLeft.png')" />
        <div ref="divBoxNode" class="tabBoxDiv">
            <ul ref="ulBoxNode" class="tabUlDiv">
                <li :class=" routerName == item.name ? 'tabs isNowRouter' : 'tabs' " ref="liBoxNode" @click="goPage(item)" v-for="(item, index) in tabDatas" :key="index">
                    <span class="title">{{item.meta.pageTitle}}</span>
                    <span class="del" v-if="tabDatas.length > 1" @click.stop="delInclude(item.name)">×</span>
                </li>
            </ul>
        </div>
        <img v-show="iconShow" @click="ToRightFn" :src="require('../assets/img/ToRight.png')" />
    </div>
</template>
<script>
    import { mapState } from 'vuex';
    export default {
        name: 'PageTab',
        methods: {
            delInclude(name){
                this.$store.dispatch('delInclude', name);
                this.$router.push({name: this.includeArr[this.includeArr.length - 1]});
                if(this.includeArr.length == 3){
                    this.$refs.ulBoxNode.style.left = 0;
                }
            },
            goPage(item){
                if(item.name != this.$route.name)
                    this.$router.push({name: item.name});
            },
            ToLeftFn(){
                const ulBox = this.$refs.ulBoxNode;
                const marginPX = Number(window.getComputedStyle(this.$refs.liBoxNode[0]).marginRight.slice(0, -2));
                if(Math.abs(ulBox.style.left.slice(0,-2)) <= 0){
                    return false;
                }
                ulBox.style.left = Number(ulBox.style.left.slice(0, -2)) + Number(this.$refs.liBoxNode[0].offsetWidth) + marginPX + 'px';
            },
            ToRightFn(){
                const ulBox = this.$refs.ulBoxNode;
                const divBox = this.$refs.divBoxNode;
                const marginPX = Number(window.getComputedStyle(this.$refs.liBoxNode[0]).marginRight.slice(0, -2));
                if((Math.abs(ulBox.style.left.slice(0,-2)) + divBox.offsetWidth) >= ulBox.offsetWidth){
                    return false;
                }
                ulBox.style.left = Number(ulBox.style.left.slice(0, -2)) - Number(this.$refs.liBoxNode[0].offsetWidth) - marginPX + 'px';
            }
        },
        data(){
            return{
                routerName: ''
            }
        },
        watch: {
            $route({...arg}){
                this.routerName = arg.name;
            },
        },
        computed: {
            ...mapState({
                includeArr: 'includeArr'
            }),
            tabDatas: {
                get(){
                    let arr = [];
                    this.includeArr.forEach(val => {
                        arr.push(this.$router.options.routes.find(item => item.name == val))
                    });
                    return arr;
                },
                set(){}
            },
            iconShow: {
                get(){
                    return this.includeArr.length > 3
                },
                set(){}
            },
        },
    }
</script>
<style lang="less" scoped>
    .tabStyle{
        position: absolute;
        top: 43%;
        left: 0.85rem;
        .flex();
        img{
            width: 0.2rem;
            cursor: pointer;
            &:first-child{
                margin-right: 0.1rem;
            }
            &:last-child{
                margin-left: 0.1rem;
            }
        }
        .tabBoxDiv{
            width: 3.05rem;
            height: 0.31rem;
            position: relative;
            overflow: hidden;
            .tabUlDiv{
                height: 100%;
                position: absolute;
                left: 0;
                .flex();
                transition: all 0.5s;
            }
            .tabs{
                width: 0.95rem;
                height: 100%;
                border: 0.01rem solid #006CC8;
                // padding: 0 0.1rem;
                margin-right: 0.1rem;
                border-radius: 0.16rem;
                box-sizing: border-box;
                cursor: pointer;
                .flexAround();
                align-items: center;
                &:last-child{
                    margin-right: 0;
                }
                .title{
                    display: inline-block;
                    font-size: 0.16rem;
                    color: #02D9FD;
                    line-height: 100%;
                    text-overflow:ellipsis;
                    max-width: 0.5rem;
                    overflow: hidden;
                    white-space: nowrap;
                }
                .del{
                    color: #006CC8;
                    display: inline-block;
                    text-align: center;
                    line-height: 100%;
                    font-size: 0.18rem;
                    &:hover{
                        color: #02D9FD;
                    }
                }
            }
            .isNowRouter{
                background: #052666;
            }
        }
    }
    
</style>